import PasturesAPI from "@/api/PasturesAPI"
import { Dashboard, Pastures, Filter, Map } from "@/store/modules"

const state = {
  fields: {},
  historicalROISummary: {},
  userSustainabilityBeforeRefresh: {},
  featureFlags: {},
}

const getters = {
  [Pastures.Getters.getFields]: state => Object.values(state.fields),
  [Pastures.Getters.getFeatureFlags]: state => state.featureFlags,
}


const mutations = {
  [Pastures.Mutations.setFields](state, fields) {
    const fieldsDict = {}
    const historicalROISummary = {}
    fields.forEach(field => {
      const historicalROIByYear = {}
      const historicalROI = field.historical_roi || []
      historicalROI.forEach(roi => (historicalROIByYear[roi.year] = roi))
      field["historicalROI"] = historicalROIByYear
      fieldsDict[field.id] = field
    })

    state.fields = fieldsDict
    state.historicalROISummary = historicalROISummary
  },

  [Pastures.Mutations.updateFields](state, fields) {
    for (const field of fields) {
      // this historical roi stuff really doesn't belong here (or in setFields)
      const historicalROIByYear = {}
      const historicalROI = field.historical_roi || []
      historicalROI.forEach(roi => (historicalROIByYear[roi.year] = roi))
      field["historicalROI"] = historicalROIByYear
      state.fields[field.id] = field
    }
  },

  [Pastures.Mutations.updateRegenPractice](state, scenarioSummaries) {
    const fieldId = scenarioSummaries.field_id
    const scenarios = scenarioSummaries.scenario

    const scenarioByField = []
    scenarios.forEach(scenario => {
      scenarioByField.push(scenario)
    })

    state.fields[fieldId].daycent[0].scenario = scenarioByField
    state.fields = Object.assign({}, state.fields)
  },

  [Pastures.Mutations.updateUserSustainability](state, sustainability) {
    state.userSustainabilityBeforeRefresh = sustainability
  },

  [Pastures.Mutations.clearUserSustainability](state) {
    state.userSustainabilityBeforeRefresh = {}
  },

  [Pastures.Mutations.setFeatureFlags](state, featureFlags) {
    for (const flag of featureFlags) {
      state.featureFlags[flag.feature_name] = flag.enabled
    }
  }
}

const actions = {
  [Pastures.Actions.batchDelete]({ dispatch }, fieldIds) {
    return new Promise(resolve => {
      PasturesAPI.batchDelete(fieldIds).then(() => {
        dispatch(Pastures.Actions.fetchFields)
        resolve()
      })
    })
  },

  [Pastures.Actions.batchUpdate]({ dispatch }, payload) {
    return new Promise(resolve => {
      PasturesAPI.batchUpdate(payload).then(() => {
        dispatch(Pastures.Actions.fetchFields)
        resolve()
      })
    })
  },

  [Pastures.Actions.ignoreGeoPackages]({ dispatch }, payload) {
    return new Promise(resolve => {
      PasturesAPI.ignoreGeoPackages(payload).then(() => {
        dispatch(Pastures.Actions.fetchFields)
        resolve()
      })
    })
  },

  [Pastures.Actions.fetchFields]({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      try {
        PasturesAPI.list().then(response => {
          commit(Pastures.Mutations.setFields, response.data)
          commit(
            Dashboard.Mutations.initializeCropDesignerSettings,
            response.data
          )
          commit(Filter.Mutations.setFields, response.data)
          dispatch(Map.Actions.fetchMapData, true)
          resolve()
        })
      } catch (e) {
        console.log("Fetch fields catch(e): ", e)
        commit(Map.Mutations.setIsFetching, false)
        reject(e)
      }
    })
  },

  [Pastures.Actions.fetchField]({ commit }, payload) {
    return new Promise(resolve => {
      PasturesAPI.get(payload.fieldId).then(response => {
        commit(Pastures.Mutations.updateFields, response.data)
        resolve()
      })
    })
  },

  [Pastures.Actions.fetchFieldsSkinny]({ commit }) {
    // PasturesAPI.list().then(response => {
    //   commit(Pastures.Mutations.setFields, response.data)
    // })
    return new Promise(resolve => {
      PasturesAPI.list().then(response => {
        commit(Pastures.Mutations.setFields, response.data)
        resolve()
      })
    })
  },

  [Pastures.Actions.updateRegenPractice]({ commit }, payload) {
    commit(Pastures.Mutations.updateRegenPractice, payload)
  },

  [Pastures.Actions.updateUserSustainability]({ commit }, payload) {
    commit(Pastures.Mutations.updateUserSustainability, payload)
  },

  [Pastures.Actions.clearUserSustainability]({ commit }) {
    commit(Pastures.Mutations.clearUserSustainability)
  },

  [Pastures.Actions.fetchFeatureFlags]({ commit }) {
    return new Promise(resolve => {
      PasturesAPI.getFeatureFlags().then(response => {
        commit(Pastures.Mutations.setFeatureFlags, response.data)
        resolve()
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
